import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { PhoneNumberInput } from '@dreryk/react-components';

type PhoneNumberFieldProps = {
   readonly register: FormContextValues['register'];
};

const PhoneNumberField = (props: PhoneNumberFieldProps): JSX.Element => {
   return (
      <PhoneNumberInput
         controller={props.register('phoneNumber')}
         label={commonTranslationKeys.phone}
         testId={'phoneNumber'}
      />
   );
};

export { PhoneNumberField };
